import React from "react";
import DataTableBase from "./dataTableBase";
import { useOrganisationContacts } from "../../hooks/useOrganisations";
import { CircularProgress, Alert } from "@mui/material";

export default function OrganisationContacts(props) {
  const { organisation_id } = props;

  const {
    data: contacts = [],
    isLoading,
    error,
  } = useOrganisationContacts(organisation_id, { enabled: !!organisation_id });

  const contactsColumns = [
    {
      name: "id",
      label: "ID",
      options: {
        sort: true,
        display: false,
      },
    },
    {
      name: "name",
      label: "Name",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "contact_method",
      label: "Contact Method",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "email",
      label: "Email",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "phone",
      label: "Phone",
      options: {
        sort: true,
        filter: true,
      },
    },
  ];

  if (isLoading) {
    return <CircularProgress />;
  }

  if (error) {
    return <Alert severity="error">Failed to load organisation contacts</Alert>;
  }

  return (
    <DataTableBase
      title={"Organisation Contacts"}
      data={contacts}
      columns={contactsColumns}
      orderby="time_created"
      orderdirection="desc"
    />
  );
}
